(() => {
  if (window.__msCustomCaseLandingReady) return;
  window.__msCustomCaseLandingReady = true;

  const labels = {
    iphone: { en: 'iPhone', fr: 'iPhone' },
    samsung: { en: 'Samsung', fr: 'Samsung' },
    airpods: { en: 'AirPods', fr: 'AirPods' },
    tablet: { en: 'Tablet', fr: 'Tablette' }
  };

  const locale = () => document.documentElement.lang?.toLowerCase().startsWith('fr') ? 'fr' : 'en';

  const modelMatrix = [
    {
      "device": "iphone",
      "label": "iPhone 7/8",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": false,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone SE",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": false,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone X/XS",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": false,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone XR",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": false,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 11",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 11 Pro",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 11 Pro Max",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 12",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 12 mini",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 12 Pro",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 12 Pro Max",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 13",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 13 mini",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 13 Pro",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 13 Pro Max",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 14",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 14 Plus",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 14 Pro",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 14 Pro Max",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 15",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 15 Plus",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 15 Pro",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 15 Pro Max",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 16",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 16 Plus",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 16 Pro",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 16 Pro Max",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 17",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 17 Air",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 17 Pro",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 17 Pro Max",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": true,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 18 Pro",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": false,
      "clear": false,
      "snap": false,
      "rubber": false
    },
    {
      "device": "iphone",
      "label": "iPhone 18 Pro Max",
      "tough": true,
      "magsafeTough": true,
      "magsafeClear": false,
      "clear": false,
      "snap": false,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S10",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S10 Plus",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S10e",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S20",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S20 FE",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S20 Plus",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S20 Ultra",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S21",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S21 FE",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S21 Plus",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S21 Ultra",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S22",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S22 Plus",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S22 Ultra",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S23",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S23 Plus",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S23 Ultra",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S24",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S24 Plus",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S24 Ultra",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S25",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S25 Plus",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S25 Ultra",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": true,
      "snap": true,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S26",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": false,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S26 Plus",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": false,
      "rubber": false
    },
    {
      "device": "samsung",
      "label": "Samsung Galaxy S26 Ultra",
      "tough": true,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": false,
      "rubber": false
    },
    {
      "device": "airpods",
      "label": "AirPods Gen1",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": false,
      "rubber": true
    },
    {
      "device": "airpods",
      "label": "AirPods Gen2",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": false,
      "rubber": true
    },
    {
      "device": "airpods",
      "label": "AirPods Gen3",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": false,
      "rubber": true
    },
    {
      "device": "airpods",
      "label": "AirPods Pro Gen1",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": false,
      "rubber": true
    },
    {
      "device": "airpods",
      "label": "AirPods Pro Gen2",
      "tough": false,
      "magsafeTough": false,
      "magsafeClear": false,
      "clear": false,
      "snap": false,
      "rubber": true
    }
  ];

  const renderModelButtons = (root = document) => {
    root.querySelectorAll('[data-pod-model-grid]').forEach((grid) => {
      grid.replaceChildren();
      modelMatrix.forEach((model) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ms-pod__model-choice';
        button.setAttribute('data-pod-model-choice', '');
        button.dataset.podDevice = model.device;
        button.dataset.podModelLabel = model.label;
        button.dataset.podAvailableTough = String(model.tough);
        button.dataset.podAvailableMagsafeTough = String(model.magsafeTough);
        button.dataset.podAvailableMagsafeClear = String(model.magsafeClear);
        button.dataset.podAvailableClear = String(model.clear);
        button.dataset.podAvailableSnap = String(model.snap);
        button.dataset.podAvailableRubber = String(model.rubber);
        button.setAttribute('aria-pressed', 'false');
        button.hidden = true;
        const strong = document.createElement('strong');
        strong.textContent = model.label;
        button.appendChild(strong);
        grid.appendChild(button);
      });
    });
  };

  const setDeviceLabels = (device) => {
    document.querySelectorAll('[data-pod-device-name]').forEach((el) => {
      el.textContent = labels[device]?.[locale()] || device;
    });
  };

  const setModelLabels = (device) => {
    document.querySelectorAll('[data-pod-model-panel]').forEach((panel) => {
      const isAirPods = device === 'airpods';
      const heading = panel.querySelector('[data-pod-model-heading]');
      const help = panel.querySelector('[data-pod-model-help]');
      if (heading) {
        heading.textContent = isAirPods
          ? panel.dataset.podAirpodsModelLabel || ''
          : panel.dataset.podPhoneModelLabel || '';
      }
      if (help) {
        help.textContent = isAirPods
          ? panel.dataset.podAirpodsModelHelp || ''
          : panel.dataset.podPhoneModelHelp || '';
      }
    });
  };

  const setPreview = (family, title, model = '') => {
    document.querySelectorAll('[data-pod-config-preview]').forEach((preview) => {
      preview.dataset.podPreviewFamily = family || 'neutral';
      const titleEl = preview.querySelector('[data-pod-preview-title]');
      const modelEl = preview.querySelector('[data-pod-preview-model]');
      if (titleEl && title) titleEl.textContent = title;
      if (modelEl) modelEl.textContent = model;
    });
  };

  const getDeviceSection = () => document.querySelector('[data-pod-segment="device"]');

  const getSelectedFamilyTitle = () =>
    document.querySelector('[data-pod-family-choice][aria-pressed="true"]')?.dataset.podFamilyTitle || '';

  const setStep1Stage = (stage) => {
    const section = getDeviceSection();
    if (!section) return;

    const brandComplete = stage === 'model' || stage === 'complete';
    const complete = stage === 'complete';

    section.dataset.podStepStage = stage;
    section.classList.toggle('is-brand-complete', brandComplete);
    section.classList.toggle('is-complete', complete);

    section.querySelectorAll('[data-pod-step-change]').forEach((button) => {
      button.hidden = !(stage === 'model' || stage === 'complete');
    });
  };

  const expandStep1ForEdit = () => {
    const section = getDeviceSection();
    if (!section) return;
    setStep1Stage('editing');
    document.querySelectorAll('[data-pod-case-section]').forEach((el) => { el.hidden = true; });
    document.querySelectorAll('[data-pod-personalize-section]').forEach((el) => { el.hidden = true; });
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const resetDeviceStage = () => {
    document.querySelectorAll('[data-pod-device-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', 'false');
    });
    document.querySelectorAll('[data-pod-model-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', 'false');
      item.hidden = true;
    });
    document.querySelectorAll('[data-pod-selected-model]').forEach((el) => { el.textContent = ''; });
    document.querySelectorAll('[data-pod-model-panel]').forEach((el) => { el.hidden = true; });
    document.querySelectorAll('[data-pod-device-continue]').forEach((el) => { el.hidden = true; });
    document.querySelectorAll('[data-pod-case-section]').forEach((el) => { el.hidden = true; });
    document.querySelectorAll('[data-pod-personalize-section]').forEach((el) => { el.hidden = true; });
    setStep1Stage('initial');
    resetCaseTargets();
  };

  const showFamilyJourney = (button) => {
    const family = button.dataset.podFamilyChoice;
    document.querySelectorAll('[data-pod-family-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === button));
    });

    resetDeviceStage();

    document.querySelectorAll('[data-pod-family-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.podFamilyPanel !== family;
    });

    setPreview(family, button.dataset.podFamilyTitle || '', button.dataset.podPreviewPrompt || '');

    if (family === 'airpods') {
      showDeviceJourney('airpods');
    } else {
      setStep1Stage('brand');
    }
  };

  const filterCases = (device) => {
    let visible = 0;
    document.querySelectorAll('[data-pod-case-item]').forEach((item) => {
      const show = item.dataset.podDevice === device;
      item.hidden = !show;
      if (show) visible += 1;
    });
    const empty = document.querySelector('[data-pod-case-empty]');
    if (empty) empty.hidden = visible > 0;
  };

  const setCaseLink = (link, url) => {
    const label = link.querySelector('[data-pod-case-link-text]');
    if (url) {
      link.href = url;
      link.classList.remove('ms-pod__case-link--disabled');
      link.removeAttribute('aria-disabled');
      link.removeAttribute('tabindex');
      if (label) label.textContent = link.dataset.podActiveLabel || '';
    } else {
      link.removeAttribute('href');
      link.classList.add('ms-pod__case-link--disabled');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
      if (label) label.textContent = link.dataset.podDisabledLabel || '';
    }
  };

  const applyCaseTargets = (modelButton) => {
    const model = modelButton.dataset.podModelLabel || '';
    const device = modelButton.dataset.podDevice || '';
    const availability = {
      tough: modelButton.dataset.podAvailableTough === 'true',
      magsafe_tough: modelButton.dataset.podAvailableMagsafeTough === 'true',
      magsafe_clear: modelButton.dataset.podAvailableMagsafeClear === 'true',
      clear: modelButton.dataset.podAvailableClear === 'true',
      snap: modelButton.dataset.podAvailableSnap === 'true',
      rubber: modelButton.dataset.podAvailableRubber === 'true'
    };

    let visible = 0;
    const visibleItems = [];

    document.querySelectorAll('[data-pod-case-item]').forEach((item) => {
      const link = item.querySelector('[data-pod-case-link]');
      const style = link?.dataset.podCaseStyle || '';
      const show = item.dataset.podDevice === device && availability[style] === true;
      item.hidden = !show;

      if (!show || !link) {
        if (link) setCaseLink(link, '');
        return;
      }

      visible += 1;
      visibleItems.push(item);
      const baseUrl = link.dataset.podBaseUrl || '';
      if (!baseUrl || !model) {
        setCaseLink(link, '');
        return;
      }

      const target = new URL(baseUrl, window.location.origin);
      target.searchParams.set('ms_model', model);
      setCaseLink(link, target.pathname + target.search + target.hash);
    });

    const grid = document.querySelector('[data-pod-case-grid]');
    if (grid) {
      grid.classList.toggle('is-single', visible === 1);
      grid.classList.toggle('is-multiple', visible > 1);
    }

    const caseTitle = visible === 1
      ? visibleItems[0]?.querySelector('h3')?.textContent?.trim() || ''
      : '';

    const referenceImage = visible === 1
      ? visibleItems[0]?.querySelector('.ms-pod__case-option-media img')
      : null;
    const referenceSrc = referenceImage?.currentSrc || referenceImage?.src || '';

    document.querySelectorAll('[data-pod-personalize-case]').forEach((el) => {
      el.textContent = caseTitle || el.dataset.podCasePending || '';
    });

    document.querySelectorAll('[data-pod-customize-reference]').forEach((img) => {
      if (referenceSrc) {
        img.src = referenceSrc;
        img.alt = caseTitle || '';
        img.hidden = false;
      } else {
        img.removeAttribute('src');
        img.alt = '';
        img.hidden = true;
      }
    });

    document.querySelectorAll('[data-pod-customize-neutral]').forEach((neutral) => {
      neutral.hidden = Boolean(referenceSrc);
    });

    document.querySelectorAll('[data-pod-personalize-preview]').forEach((preview) => {
      preview.classList.toggle('has-reference', Boolean(referenceSrc));
    });

    const empty = document.querySelector('[data-pod-case-empty]');
    if (empty) empty.hidden = visible > 0;
  };

  const resetCaseTargets = () => {
    document.querySelectorAll('[data-pod-case-link]').forEach((link) => setCaseLink(link, ''));
    document.querySelectorAll('[data-pod-case-grid]').forEach((grid) => {
      grid.classList.remove('is-single', 'is-multiple');
    });
    document.querySelectorAll('[data-pod-customize-reference]').forEach((img) => {
      img.removeAttribute('src');
      img.alt = '';
      img.hidden = true;
    });
    document.querySelectorAll('[data-pod-customize-neutral]').forEach((neutral) => {
      neutral.hidden = false;
    });
    document.querySelectorAll('[data-pod-personalize-preview]').forEach((preview) => {
      preview.classList.remove('has-reference');
    });
  };

  const filterModels = (device) => {
    let visible = 0;
    document.querySelectorAll('[data-pod-model-choice]').forEach((button) => {
      const show = button.dataset.podDevice === device;
      button.hidden = !show;
      button.setAttribute('aria-pressed', 'false');
      if (show) visible += 1;
    });
    document.querySelectorAll('[data-pod-model-empty]').forEach((empty) => {
      empty.hidden = visible > 0;
    });
    return visible;
  };

  const setModelContinueState = (ready) => {
    document.querySelectorAll('[data-pod-device-continue]').forEach((el) => {
      el.hidden = false;
    });

    document.querySelectorAll('[data-pod-model-next]').forEach((link) => {
      const label = link.querySelector('[data-pod-model-next-text]');
      if (ready) {
        link.href = '#pod-case';
        link.classList.remove('ms-pod__next--disabled');
        link.removeAttribute('aria-disabled');
        link.removeAttribute('tabindex');
        if (label) label.textContent = link.dataset.podActiveLabel || '';
      } else {
        link.removeAttribute('href');
        link.classList.add('ms-pod__next--disabled');
        link.setAttribute('aria-disabled', 'true');
        link.setAttribute('tabindex', '-1');
        if (label) label.textContent = link.dataset.podIdleLabel || '';
      }
    });
  };

  const showDeviceJourney = (device) => {
    setDeviceLabels(device);
    setModelLabels(device);
    filterModels(device);
    resetCaseTargets();

    document.querySelectorAll('[data-pod-selected-model]').forEach((el) => { el.textContent = ''; });
    document.querySelectorAll('[data-pod-model-panel]').forEach((el) => { el.hidden = false; });
    setModelContinueState(false);
    document.querySelectorAll('[data-pod-case-section]').forEach((el) => { el.hidden = true; });
    document.querySelectorAll('[data-pod-personalize-section]').forEach((el) => { el.hidden = true; });

    const familyTitle = getSelectedFamilyTitle();

    if (device === 'airpods') {
      const familyButton = document.querySelector('[data-pod-family-choice="airpods"]');
      setPreview(
        'airpods',
        familyTitle || labels.airpods?.[locale()] || 'AirPods',
        familyButton?.dataset.podPreviewPrompt || ''
      );
    } else {
      const deviceButton = document.querySelector('[data-pod-device-choice="' + device + '"]');
      const deviceTitle = deviceButton?.dataset.podPreviewTitle || labels[device]?.[locale()] || device;
      setPreview(
        'phone',
        [familyTitle, deviceTitle].filter(Boolean).join(' → '),
        deviceButton?.dataset.podPreviewPrompt || ''
      );
    }

    setStep1Stage('model');
  };

  const selectModel = (button) => {
    const device = button.dataset.podDevice;
    document.querySelectorAll('[data-pod-model-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === button));
    });
    setDeviceLabels(device);
    setModelLabels(device);
    document.querySelectorAll('[data-pod-selected-model]').forEach((el) => {
      el.textContent = button.dataset.podModelLabel || '';
    });
    filterCases(device);
    applyCaseTargets(button);
    setModelContinueState(true);

    const familyTitle = getSelectedFamilyTitle();
    const deviceTitle = labels[device]?.[locale()] || device;
    const summaryTitle = device === 'airpods'
      ? familyTitle || deviceTitle
      : [familyTitle, deviceTitle].filter(Boolean).join(' → ');

    setPreview(
      device === 'airpods' ? 'airpods' : 'phone',
      summaryTitle,
      button.dataset.podModelLabel || ''
    );

    document.querySelectorAll('[data-pod-case-section]').forEach((el) => { el.hidden = false; });
    document.querySelectorAll('[data-pod-personalize-section]').forEach((el) => { el.hidden = false; });
    document.querySelectorAll('[data-pod-personalize-preview]').forEach((preview) => {
      preview.dataset.podDevice = device;
    });
  };

  const bindMockupRotators = (root = document) => {
    root.querySelectorAll('[data-pod-mockup-rotator]:not([data-pod-rotator-bound])').forEach((rotator) => {
      rotator.dataset.podRotatorBound = 'true';
      const items = Array.from(rotator.querySelectorAll('[data-pod-mockup-item]'));
      if (items.length <= 1) return;

      let index = 0;
      let timer = null;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const autoRotate = rotator.dataset.podAutoRotate === 'true' && !reducedMotion && !mobile;

      const show = (nextIndex) => {
        index = nextIndex % items.length;
        items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      };
      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      const start = () => {
        if (!autoRotate || timer) return;
        timer = window.setInterval(() => show(index + 1), 4800);
      };

      rotator.addEventListener('mouseenter', stop);
      rotator.addEventListener('mouseleave', start);
      rotator.addEventListener('focusin', stop);
      rotator.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });
      start();
    });
  };

  const bind = (root = document) => {
    root.querySelectorAll('[data-pod-family-choice]:not([data-pod-family-bound])').forEach((button) => {
      button.dataset.podFamilyBound = 'true';
      button.addEventListener('click', () => showFamilyJourney(button));
    });

    root.querySelectorAll('[data-pod-step-change]:not([data-pod-change-bound])').forEach((button) => {
      button.dataset.podChangeBound = 'true';
      button.addEventListener('click', expandStep1ForEdit);
    });

    root.querySelectorAll('[data-pod-device-choice]:not([data-ms-bound])').forEach((button) => {
      button.dataset.msBound = 'true';
      button.addEventListener('click', () => {
        document.querySelectorAll('[data-pod-device-choice]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        showDeviceJourney(button.dataset.podDeviceChoice);
      });
    });

    root.querySelectorAll('[data-pod-model-choice]:not([data-pod-model-bound])').forEach((button) => {
      button.dataset.podModelBound = 'true';
      button.addEventListener('click', () => selectModel(button));
    });

    root.querySelectorAll('[data-pod-model-next]:not([data-pod-next-bound])').forEach((link) => {
      link.dataset.podNextBound = 'true';
      link.addEventListener('click', (event) => {
        if (link.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        setStep1Stage('complete');
      });
    });

    root.querySelectorAll('[data-pod-case-link]:not([data-pod-link-bound])').forEach((link) => {
      link.dataset.podLinkBound = 'true';
      link.addEventListener('click', (event) => {
        if (link.getAttribute('aria-disabled') === 'true') event.preventDefault();
      });
    });

    bindMockupRotators(root);
  };

  renderModelButtons();
  bind();

  // T-089: restore previous device/model on an explicit editor Back link.
  const restoreFromEditor = () => {
    const params = new URLSearchParams(window.location.search);
    const step = params.get('ms_return_step');
    if (step !== 'device' && step !== 'case') return;
    const device = params.get('ms_device');
    const model = params.get('ms_model');
    const family = device === 'airpods' ? 'airpods' : 'phone';
    const familyButton = document.querySelector('[data-pod-family-choice="' + family + '"]');
    if (!familyButton) return;
    showFamilyJourney(familyButton);
    if (family === 'phone') {
      const brandButton = document.querySelector('[data-pod-device-choice="' + device + '"]');
      if (brandButton) brandButton.click();
    }
    if (model) {
      const modelButton = Array.from(document.querySelectorAll('[data-pod-model-choice]'))
        .find(el => el.dataset.podDevice === device && el.dataset.podModelLabel === model);
      if (modelButton) selectModel(modelButton);
    }
    const caseVisible = !!document.querySelector('[data-pod-case-section]:not([hidden])');
    const targetId = step === 'case' && caseVisible ? 'pod-case' : 'pod-device';
    const clean = new URL(window.location.href);
    clean.searchParams.delete('ms_return_step');
    clean.hash = targetId;
    window.history.replaceState(window.history.state, '', clean.href);
    window.requestAnimationFrame(() => document.getElementById(targetId)?.scrollIntoView({block:'start'}));
  };
  restoreFromEditor();


  document.addEventListener('shopify:section:load', (event) => {
    renderModelButtons(event.target);
    bind(event.target);
    const selectedDevice = document.querySelector('[data-pod-device-choice][aria-pressed="true"]')?.dataset.podDeviceChoice;
    if (selectedDevice) showDeviceJourney(selectedDevice);
  });
})();
